import React from 'react';
import { CheckCircleIcon, StepItemIcon, StepItemIndicator } from '@razorpay/blade/components';
import { StepMarkerType } from './utils';

export const renderMarker = (markerConfig: StepMarkerType): React.ReactElement => {
  if (markerConfig.type === 'icon') {
    return <StepItemIcon icon={CheckCircleIcon} color={markerConfig.color} />;
  }
  return <StepItemIndicator color={markerConfig.color} />;
};
